<div class="row" *ngFor="let hotel of day.hotels[0]?.hotels">
  <div class="col-12 pl-4 pt-2">
    <span class="overview-icons"> <app-service-icon [icon]="'hotel'" [customPath]="getServiceIconPath('hotel')"></app-service-icon> </span>
    <span class="text-capitalize">{{ hotel.name?.toLowerCase() }}</span>
  </div>
</div>
